import * as Bixby from '$/core';

export interface UserEmailConfirmationState {
  isLoading: boolean;
  error?: string;
  success: boolean;
  tokenInvalid: boolean;
}

export const USER_EMAIL_CONFIRMATION_INPROGESS = 'USER_EMAIL_CONFIRMATION_INPROGESS';
export const USER_EMAIL_CONFIRMATION_SUCCESS = 'USER_EMAIL_CONFIRMATION_SUCCESS';
export const USER_EMAIL_CONFIRMATION_FAILURE = 'USER_EMAIL_CONFIRMATION_FAILURE';
export const VERIFY_USER_EMAIL_CONFIRMATION_INPROGESS = 'VERIFY_USER_EMAIL_CONFIRMATION_INPROGESS';
export const VERIFY_USER_EMAIL_CONFIRMATION_SUCCESS = 'VERIFY_USER_EMAIL_CONFIRMATION_SUCCESS';
export const VERIFY_USER_EMAIL_CONFIRMATION_FAILURE = 'VERIFY_USER_EMAIL_CONFIRMATION_FAILURE';

interface UserEmailConfirmationInProgress extends Bixby.Models.BixbyAction {
  type: typeof USER_EMAIL_CONFIRMATION_INPROGESS;
}

interface UserEmailConfirmationRequestSuccess extends Bixby.Models.BixbyAction {
  type: typeof USER_EMAIL_CONFIRMATION_SUCCESS;
}

interface UserEmailConfirmationRequestFailure extends Bixby.Models.BixbyAction {
  type: typeof USER_EMAIL_CONFIRMATION_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface VerifyUserEmailConfirmationInProgress extends Bixby.Models.BixbyAction {
  type: typeof VERIFY_USER_EMAIL_CONFIRMATION_INPROGESS;
}

interface VerifyUserEmailConfirmationRequestSuccess extends Bixby.Models.BixbyAction {
  type: typeof VERIFY_USER_EMAIL_CONFIRMATION_SUCCESS;
  payload: boolean;
}

interface VerifyUserEmailConfirmationRequestFailure extends Bixby.Models.BixbyAction {
  type: typeof VERIFY_USER_EMAIL_CONFIRMATION_FAILURE;
  payload: Bixby.Models.BixbyError;
}

export type UserEmailConfirmationActionTypes =
  | UserEmailConfirmationInProgress
  | UserEmailConfirmationRequestSuccess
  | UserEmailConfirmationRequestFailure
  | VerifyUserEmailConfirmationInProgress
  | VerifyUserEmailConfirmationRequestSuccess
  | VerifyUserEmailConfirmationRequestFailure;
